import React from 'react';

import { Flex } from '@chakra-ui/react';
import { format } from 'date-fns';

import { isMobileView } from 'constants/isMobileView';

import { Avatar } from 'uiToolkitV1/Avatar';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { TextLabel } from 'uiToolkitV1/Typography';

const RELATION_TYPE = {
  REPORTEE: 'Reportee',
  MANAGER: 'Manager',
  PEER: 'Peer',
  SKIP_REPORTEE: 'Skip Reportee',
  SKIP_MANAGER: 'Skip Manager',
};

const ArchivedEmployeeData = (params) => {
  const { employeeMiniProfile } = params?.data?.employee?.value ?? {};
  const { relationType } = params?.data?.employee?.value ?? '';
  const lastOneOnOneData = params?.data?.lastOneOnOneTime?.value ?? '';
  const lastOneOnoneDate = lastOneOnOneData ? format(new Date(lastOneOnOneData), 'PPp') : 'No 1:1 completed';

  return (
    <Flex
      flexDir={isMobileView() && 'column'}
      w="100%"
      h="100%"
      alignItems={!isMobileView() && 'center'}
      mt={isMobileView() && '8px'}
    >
      <ListItemComp
        isBoldText={false}
        withoutBackground
        title={employeeMiniProfile?.displayName}
        subTitle={RELATION_TYPE[relationType] ?? ''}
        LeftComponent={() => <Avatar src={employeeMiniProfile?.profilePhoto} />}
      />
      {isMobileView() && (
        <TextLabel color="#666666" ml={8}>
          Past 1:1 : {lastOneOnoneDate}
        </TextLabel>
      )}
    </Flex>
  );
};

export default ArchivedEmployeeData;
